import Container from "Components/Container/Container";
import React, { useLayoutEffect, useRef, useState } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CaretUp } from "@phosphor-icons/react";
const MobileServices = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const slideRefs = useRef([]);
  const [maxHeight, setMaxHeight] = useState(0);
  const { t } = useTranslation();
  useLayoutEffect(() => {
    // Ensure slideRefs.current is populated
    if (
      slideRefs.current.length === 0 ||
      slideRefs.current.every((ref) => ref === null)
    ) {
      return;
    }

    // Calculate the maximum height after the DOM is fully rendered
    const heights = slideRefs.current.map((slide) => {
      if (slide) {
        return slide.offsetHeight;
      }
      return 0;
    });

    const maxHeight = Math.max(...heights);

    setMaxHeight(maxHeight);
  }, [data]);

  return (
    <section className="xl:hidden pb-32">
      <Container>
        <Swiper
          spaceBetween={6}
          slidesPerView={1.2}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          modules={[Autoplay, Navigation]}
          className=""
          speed={1000}
        >
          {data
            ?.slice(0, 3)
            ?.map(({ text, title, sub_title, image, slug }, index) => (
              <SwiperSlide
                ref={(el) => {
                  slideRefs.current[index] = el;
                }}
                style={{
                  height: maxHeight ? `${maxHeight}px` : "auto",
                }}
                key={index}
              >
                <div
                  style={{ backgroundImage: `url(${image})` }}
                  className="h-full py-12 flex items-center justify-center"
                >
                  <Container>
                    <div>
                      <h6 className="titles-font text-3xl lg:text-4xl xx:text-5xl text-primary capitalize">
                        {title}
                      </h6>
                      <p className="mt-4 text-[#333] text-lg">{text}</p>
                      <Link
                        to={`/serviceDetailes/${slug}`}
                        className="flex font-bold mt-4 items-center gap-x-2 text-sm"
                      >
                        <CaretUp size={28} weight="fill" />
                        {t("learn_more")}
                      </Link>
                    </div>
                  </Container>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default MobileServices;
